import { FIELD_SECTION } from 'components/pages/reports/consts';

const PERMISSION_KEY_APSALAR = 'display_apsalar_fields';

export const shelfPeriods = {
    type: 'periods',
    addButton: {
        show: false,
    },
    group: {
        type: 'multi',
        data: {
            buttonStyle: {
                width: '90px',
            },
        },
        subText: 'STATIC.PAGES.REPORTS.COHORT_PERIOD_SUB_TEXT',
    },
    label: 'STATIC.COHORT_PERIODS',
    section: FIELD_SECTION.COHORT_DATA,
};

export const shelfIOSPeriods = {
    type: 'unifiedCohortPeriods',
    addButton: {
        show: false,
    },
    group: {
        type: 'multi',
        data: {
            buttonStyle: {
                width: '90px',
            },
        },
    },
    label: 'STATIC.COHORT_PERIODS',
    bigLabelTooltip: 'STATIC.TOOLTIPS.UNIFIED_COHORT_PERIODS',
    section: FIELD_SECTION.UNIFIED_DATA_TYPES,
};

export const shelfSkanPeriods = {
    ...shelfPeriods,
    group: { ...shelfPeriods.group },
    label: 'STATIC.SKAN_COHORT_PERIODS',
    permissionKey: PERMISSION_KEY_APSALAR,
    section: FIELD_SECTION.SKAN_ADVANCED_ANALYTICS,
};

export const shelfSkanModeledCohortPeriods = {
    type: 'skanModeledCohortPeriods',
    addButton: {
        show: false,
    },
    group: {
        type: 'multi',
        data: {
            buttonStyle: {
                width: '90px',
            },
        },
    },
    label: 'STATIC.MODELED_SKAN_COHORT_PERIODS',
};
